export default __webpack_public_path__ + "images/no-img-thumb-242.png";